export default class Messages {
    constructor(box21_api) {
        this.api = box21_api;
    }

    async inbox(project_id, options = {}) {
        let formData = new FormData();
        if (project_id) {
            formData.append('project_id', project_id);
        }
        const page = options.page != null ? options.page : 1;
        const itemsPerPage = options.itemsPerPage != null ? options.itemsPerPage : 20;
        formData.append('page', String(page));
        formData.append('itemsPerPage', String(itemsPerPage));
        if (options.search) {
            formData.append('search', options.search);
        }
        if (options.regex) {
            formData.append('regex', 'true');
        }
        return this.api.post_with_token('/messages/inbox', formData);
    }
}
